import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {format, addDays, subDays} from "date-fns";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllActivity = createAsyncThunk(
  "activity/getAllActivity",
  async (date, {rejectWithValue}) => {
    try {
      let formattedDate = format(date, "yyyy-MM-dd");
      // debugger;

      const res = await api.get(
        `${WiseBerryAPIEnv}member/team-activity-logs?date=${formattedDate}`
      );
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

let initialState = {
  activity: [],
  loading: false,
  activityLogError: null,
};

const activitySlice = createSlice({
  name: "activity_log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllActivity.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllActivity.fulfilled, (state, action) => {
        state.activity = action.payload;
        state.loading = false;
        state.activityLogError = null;
      })
      .addCase(getAllActivity.rejected, (state, action) => {
        state.loading = false;
        state.activityLogError = action.payload;
        state.activity = [];
      });
  },
});

export default activitySlice.reducer;
